import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { updateAlarm } from '@api/common';

import { IAlarmSettingsDTO } from '@interfaces/alarms/dto/alarmsDTO';

import { ESnackbarTypes } from '@enums/common';

import { ACTIVE_ALARMS, ALARM_HISTORY, ALARM_LIST, ALARM_LIST_ORAN, EDIT_ALARM } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateUpdateAlarm = (onSettledCallbacks?: Array<() => void>) => {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();

	const {
		mutate: editAlarm,
		isLoading: isLoadingEditAlarm,
	} = useMutation<IAlarmSettingsDTO>({
		mutationKey: [EDIT_ALARM],
		mutationFn: updateAlarm,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.alarmUpdated,
				type: ESnackbarTypes.success,
			}));

			if (onSettledCallbacks?.length) {
				onSettledCallbacks.forEach((callback) => callback());
			}

			return [
				queryClient.invalidateQueries([ALARM_LIST]),
				queryClient.invalidateQueries([ACTIVE_ALARMS]),
				queryClient.invalidateQueries([ALARM_HISTORY]),
				queryClient.invalidateQueries([ALARM_LIST_ORAN]),
			];
		},
	});

	return {
		editAlarm,
		isLoadingEditAlarm,
	};
};
